import * as React from 'react';
import { createDatasetDetailLink, Page } from './Paths';
import { Redirect, Route, Switch } from 'react-router-dom';
import BrowseTable from '../components/catalog/browsedatasets';
import { DatasetDetails } from 'src/components/catalog/datasetdetail/datasetDetail';
import BrowseCatalogsTable from '../components/catalog/browsecatalogs';
import BrowseDatabasesTable from '../components/catalog/browsedatabases';
import { Home } from '../components/home/home';
import { SearchHome } from 'src/components/search/search-home';
import { DatabaseDetail } from 'src/components/workspaces/dataBrowse/database/databaseDetail';
import { CatalogDetail } from 'src/components/workspaces/dataBrowse/catalog/catalogDetail';
import { Baselining } from 'src/components/permissions/myBaselining/baselining';
import { BaselineDataAccessPermission } from 'src/components/permissions/myBaselining/baselineDataAccessPermission';
import { BaselineHammerstoneGroups } from 'src/components/permissions/myBaselining/baselineHammerstoneGroups';
import { ReviewWizard } from 'src/components/reviews/reviewWizard';
import ReviewDetails from 'src/components/reviews/reviewDetails';
import { AccessReviewCustodianPage } from 'src/components/reviews/reviewCustodian';
import { AccessReviewHistoryPage } from 'src/components/reviews/reviewHistory';
import { CreateNewGroupForm } from 'src/components/common/createNewGroupForm';

export const OnboardingRoutes = (props) => (
  <Switch>
    <Route path={[Page.HOME]} exact render={(route_props) => <Home {...route_props} {...props} />} />

    <Route
      path={Page.BROWSE_CATALOGS}
      exact
      render={(route_props) => <BrowseCatalogsTable {...route_props} {...props} title='Catalogs' />}
    />
    <Route
      path={[
        Page.REDSHIFT_CATALOG_DETAILS,
        Page.REDSHIFT_SERVERLESS_CATALOG_DETAILS,
        Page.S3_TABLE_CATALOG_DETAILS,
        Page.CATALOG_DETAILS,
      ]}
      exact
      render={(route_props) => <CatalogDetail {...route_props} {...props} />}
    />

    <Route
      path={Page.BROWSE_DATABASES}
      exact
      render={(route_props) => <BrowseDatabasesTable {...route_props} {...props} title='Databases' />}
    />
    <Route
      path={[Page.DATABASE_DETAILS, Page.S3_TABLE_DATABASE_DETAILS]}
      exact
      render={(route_props) => <DatabaseDetail {...route_props} {...props} />}
    />

    <Route
      path={Page.BROWSE_DATASETS}
      exact
      render={(route_props) => (
        <BrowseTable {...route_props} {...props} title='Datasets' extraFeatures={true} disableFiltering={true} />
      )}
    />

    <Route path={Page.BASELINING} exact render={(route_props) => <Baselining {...route_props} {...props} />} />
    <Route
      path={Page.BASELINE_DATA_ACCESS_PERMISSION}
      exact
      render={(route_props) => <BaselineDataAccessPermission {...route_props} {...props} />}
    />
    <Route
      path={Page.BASELINE_HAMMERSTONE_GROUPS}
      exact
      render={(route_props) => <BaselineHammerstoneGroups {...route_props} {...props} />}
    />
    <Route path={Page.SEARCH} exact render={(route_props) => <SearchHome {...route_props} {...props} />} />
    <Route path={Page.DATASET_DETAILS} exact render={(route_props) => <DatasetDetails {...route_props} {...props} />} />

    {/* Workspace dataset details page will redirect to the group-level page when user is not onboarded*/}
    <Route path={Page.DATASET_DETAILS} exact render={(route_props) => <DatasetDetails {...route_props} {...props} />} />

    <Route path={Page.DEPRECATED_CATALOG} exact render={(_) => <Redirect to={Page.BROWSE_DATASETS} />} />
    <Route
      path={Page.DEPRECATED_CATALOG_DETAILS}
      exact
      render={(route_props) => {
        return <Redirect to={createDatasetDetailLink(route_props.match.params.id)} />;
      }}
    />
    <Route path={Page.REVIEWS} exact render={(route_props) => <ReviewWizard {...route_props} {...props} />} />
    <Route path={Page.REVIEW_DETAILS} exact render={(route_props) => <ReviewDetails {...route_props} {...props} />} />
    <Route
      path={Page.REVIEW_CUSTODIAN}
      exact
      render={(route_props) => <AccessReviewCustodianPage {...route_props} {...props} />}
    />
    <Route
      path={Page.REVIEW_HISTORY}
      exact
      render={(route_props) => <AccessReviewHistoryPage {...route_props} {...props} />}
    />

    <Route exact path={Page.ONBOARDING} render={() => <CreateNewGroupForm {...props} />} />
    <Route path='*' render={(_) => <Redirect to={Page.HOME} />} />
  </Switch>
);

export default OnboardingRoutes;
